import { render, staticRenderFns } from "./PlacesList.vue?vue&type=template&id=146fa108&scoped=true"
import script from "./PlacesList.vue?vue&type=script&lang=js"
export * from "./PlacesList.vue?vue&type=script&lang=js"
import style0 from "./PlacesList.vue?vue&type=style&index=0&id=146fa108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146fa108",
  null
  
)

export default component.exports